import CloseIcon from '@mui/icons-material/Close'
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { useFormik } from 'formik'
import React, { FC, useEffect } from 'react'
import * as yup from 'yup'
import { OIDC_SESSION_STORAGE } from '../../api/endpoints.constants'
import { CodeVerification } from '../../components/CodeVerification'
import { useSessionStorage } from '../../hooks/useSessionStorage'
import { useUserStore } from '../../store/storeUser'
import { useWrapperStore } from '../../store/storeWrapper'
import { useAuth } from 'react-oidc-context'

const validationSchema = yup.object({
    email: yup
        .string()
        // .matches(EMAIL_REGEXR, EMAIL_REGEXR_ERROR)
        .required('Пожалуйста, введите Ваш email пользователя.'),
})

interface Props {
    open: boolean
    isTempUser: boolean
    onClose: () => void
}

export const ChangeEmailDialog: FC<Props> = ({ open, onClose, isTempUser = false }) => {
    const { setStateNotification, setIsTempUser } = useWrapperStore()
    const {
        email_verify_id,
        error,
        verifyEmail,
        changeEmail,
        setUserPersonalData,
        isLoadingChangeEmail,
        errorChangeEmail,
        secondStepRegistration,
        setFirstStepRegistration,
    } = useUserStore()
    const [code, setCode] = React.useState('')
    const [user, setSessionStorage] = useSessionStorage(OIDC_SESSION_STORAGE, null)
    const {
        handleSubmit,
        values,
        handleBlur,
        touched,
        errors,
        handleChange,
        isValid,
        dirty,
        resetForm,
    } = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            await changeEmail(values.email)
            setCode('')
        },
    })
    const auth = useAuth()

    useEffect(() => {
        if (errorChangeEmail) {
            setStateNotification({
                isOpen: true,
                text: errorChangeEmail,
                isError: !!errorChangeEmail,
            })
        }
    }, [errorChangeEmail])

    useEffect(() => {
        if (!isTempUser && secondStepRegistration) {
            handleClose()
        }
    }, [isTempUser, secondStepRegistration])

    const onSubmitCodeForm = async () => {
        await verifyEmail({ code, email_verify_id })
    }

    const handleCode = (code) => {
        setCode(code)
    }

    const handleClose = () => {
        onClose()
        setCode('')
        resetForm()
        setFirstStepRegistration()
    }

    const handleCloseFinish = () => {
        onClose()
        auth.signinSilent()
        // setSessionStorage({ ...user, profile: { ...user.profile, is_temp: false } })
        if (isTempUser) {
          ym(100275765,'reachGoal','registrationAA')
          setIsTempUser(false)
        }
    }

    const Content = !email_verify_id ? (
        <DialogContent>
            {secondStepRegistration ? (
                <>
                    <Typography variant="h3" sx={{ textAlign: 'center', mt: 0 }}>
                        🎉 Регистрация <br /> прошла успешно! 🎉
                    </Typography>
                    <Button
                        sx={{ mt: 3, mb: 2 }}
                        fullWidth
                        variant="contained"
                        onClick={handleCloseFinish}>
                        Продолжить
                    </Button>
                </>
            ) : (
                <form onSubmit={handleSubmit}>
                    <Typography variant="body2" sx={{ color: '#5A5F72' }}>
                        {isTempUser
                            ? 'Введите email, мы пришлем вам код верификации'
                            : 'Введите новый email, мы пришлем вам код верификации'}
                    </Typography>
                    <TextField
                        required
                        sx={{ marginBottom: '16px' }}
                        margin="normal"
                        fullWidth
                        id="email"
                        name="email"
                        placeholder="Введите email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                    />
                    <Button
                        type="submit"
                        disabled={!(isValid && dirty) || isLoadingChangeEmail}
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}>
                        {isLoadingChangeEmail && <CircularProgress size={14} />}
                        Продолжить
                    </Button>
                </form>
            )}
        </DialogContent>
    ) : (
        <DialogContent
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <CodeVerification
                handleCode={handleCode}
                onSubmit={onSubmitCodeForm}
                code={code}
                error={error}
                email={values.email}
            />
        </DialogContent>
    )

    return (
        <Dialog
            PaperProps={{
                style: {
                    width: '360px',
                },
            }}
            open={open}
            onClose={handleClose}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    marginBottom: '0',
                }}>
                {isTempUser ? 'Регистрация' : 'Изменить email'}
                {!secondStepRegistration && (
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            border: '1px solid #E9EAED',
                        }}>
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
            {Content}
        </Dialog>
    )
}
